export default{
    newsDetailTitle: "联邦机器学习应用于贷款风险预测",
    newsDetailTime: "发布时间",
    newsDetailRead:"阅读量",
    newsDetailSource:"文章来源：",
    h4:"导读",
    newsDetail:[
        {
            h4:"行业动态"
        },
        {
            p:' 联邦学习可以用于追求先进的机器学习模型，同时仍然将数据保存在数据所有者手中。',
        },
        {
            p:' 通过联邦学习，可以将数据保存在金融机构手中，也可以保护数据科学家的知识产权。'
        },
        {
            p:' PySyft是由OpenMined创建的一个开源库，它通过将联邦学习与另外两个关键概念相结合来实现私有人工智能:安全多方计算(secure多方计算，SMPC)和差异隐私。',
        },
        {
            p:"了解如何在贷款风险预测等金融服务用例中使用联邦学习。"
        },
        {
            p:"由于保证了100%的隐私，联邦学习实现了与传统深度学习技术非常相似的性能。"
        },
        {
            p:"模型的强度取决于它所提供的数据，但如果数据不容易访问或包含个人身份信息，会发生什么呢?在这种情况下，数据所有者和数据科学家能否一起创建私有数据的模型?联邦学习证明，在仍然将数据保存在数据所有者手中的同时追求高级模型确实是可能的。"
        },
        {
            p:"这种新技术很容易应用于金融服务，因为银行拥有从交易历史到客户人口统计信息等极其敏感的信息。一般来说，将数据交给第三方来执行分析任务是非常危险的。但是，通过联邦学习，数据可以保存在金融机构手中，数据科学家的知识产权也可以得到保护。在本文中，我们将揭开联邦学习技术的神秘面纱，并接触到金融中的许多用例之一:贷款风险预测。"
        },
        {
            h4:"什么是联邦学习?"
        },
        {
            p:"联邦学习，简而言之，是一种通过去中心化安全地训练机器学习(ML)模型的方法。也就是说，不是聚合训练模型所需的所有数据，而是将模型发送给每个单独的数据所有者。然后，在每个数据子集上对模型进行训练后，将更新后的权重发送回协调器，并对最终模型进行平均。通过这种方法，数据永远不会离开其原始所有者的手，确保了数据所有者和数据科学家之间更高级别的安全性和信任，而不会在模型性能方面打折扣。"
        },
        {
            p:"目前，开发联邦学习模型需要额外的计算成本，而且神经网络作为最常见的联邦学习框架主要支持的算法存在局限性。尽管如此，由于数据隐私和安全方面的巨大改进，联邦学习有很大的潜力来改变模型的训练方式。"
        },
        {
            h4:"从联邦学习过渡到私有化的人工智能"
        },
        {
            p:'联邦学习作为一种方法是有效的，但它本身仍然存在一些缺陷。数据科学家的人工智能模型的知识产权如何保持隐私?数据科学家可以使用什么技术来探索私有数据集?PySyft是由OpenMined创建的一个开源库，它通过将联邦学习与另外两个关键概念相结合实现了完全私有的人工智能:安全多方计算(secure多方计算，SMPC)和差异隐私。谷歌的Tensorflow Federated还提供了联邦学习能力，因为它集成了Tensorflow和Keras作为深度学习后端。',
        },
        {
            h4:'安全多方计算',
        },
        {
            p:'假设我们有一些数据我们想对其进行操作。在这种情况下，假设我们的数据是数字6，操作是乘以2。我们如何在不知道数据的情况下让第三方来完成这个操作?当然，我们使用的是安全多方计算!我们可以将数据分成多个部分，执行操作，然后将每个部分的结果组合在一起，而不是作为一个整体来处理数据。',
        },
        {
            p:'注意，每个人只拥有部分数据(通俗地称为“共享加密”)，但我们仍然能够获得操作的正确结果。在执行乘法的情况下，SMPC相对简单;更高级的算法，如反向传播或线性代数，计算起来要困难得多。幸运的是，PySyft在一个称为“挂钩”的过程中与PyTorch集成，并将SMPC引入深度学习，允许数据所有者在不知道权重或更新的情况下训练模型。',
        },
        {
            h4:'Differential Privacy',
        },
        {
            p:'作为一名数据科学家，为了对数据集有一个基本的理解，必须查看一些统计数据。然而，数据集的任何单独记录都会以某种方式影响这些统计数据。差异隐私是隐私的一个严格的数学定义，它衡量在数据集中包含或排除个别行时，统计数据的变化程度。',
        },
        {
            p:'目前常用的隐私测量方法是 ε-differential privacy 。 ε-differential privacy 的概念是，一个人的记录不包含在某些数据中，他就拥有完全的隐私。因此，我们想限制任何统计函数对任何个体的依赖。',
        },
        {
            p:'例如，平均值平均地反映了一组中的所有条目，因此，通过观察平均值在删除或添加条目时的变化，可以计算出条目的确切值。',
        },
        {
            p:"当从统计计算中移除一个个体时，可以准确地理解被移除个体的值是什么——因此平均值不是一个差异私人统计数据。"
        },
        {
            p:"随机响应是差异私有算法的一个例子。想象一下，我们试图找出个人是否使用iPhone或Android手机。采集数据的过程如下:"
        },
        {
            p:"1、抛硬币"
        },
        {
            p:"2、如果硬币正面朝上，再抛一次，但不管抛硬币的结果如何，如实记录结果。"
        },
        {
            p:"3、如果硬币反面落地，再抛一次。如果第二个硬币正面朝上，记录为iPhone。如果是反面，就记录Android。"
        },
        {
            p:"通过这个过程(以及第二步抛硬币的过程)，每个人对自己的回答都有似是而非的推诿。 然而，大多数使用iPhone的人会这样回答，而使用Android的人也会这样回答。 因此，我们可以大致估算出拥有iPhone或Android手机的人口比例。"
        },
        {
            p:"PySyft的目标是追踪在所有与分析相关的操作中有多少隐私被丢失; 数据科学家和数据所有者现在可以合作建立“隐私预算”，并确保不会有太多的PII泄露。 "
        },
        {
            h4:"金融服务业是怎样的呢?"
        },
        {
            p:"金融服务行业的应用程序管理非常敏感的数据，这自然是联邦学习的一个很好的行业目标。 贷款风险预测是一个特定的例子——下面，我们将看到如何启动并运行一个基本的联邦学习应用程序。 这样，我们就可以看到使用PySyft创建私人AI的好处。 "
        },
        {
            p:"让我们来回顾一下通过联邦学习和PySyft启用的工作流: "
        },
        {
            p:"1、数据科学家在PyTorch中开发深度学习架构 "
        },
        {
            p:"2、PySyft加密模型并将模型发送给数据所有者  "
        },
        {
            p:"3、模型在数据所有者的前提下进行训练，由数据科学家指定训练参数(如学习率或迭代次数) "
        },
        {
            p:"4、更新后的模型从数据所有者发送回数据科学家 "
        },
        {
            p:"5、在有多个数据所有者的情况下，在总迭代的子集上训练的每个模型与其他模型平均  "
        },
        {
            p:"6、清洗和重复所需数量的训练迭代! "
        },
        {
            p:"既然已经训练了模型，那么向数据所有者获取预测的过程就非常简单了。 PySyft再次为这个过程提供了便利。"
        },
        {
            p:"1、通过PySyft加密将模型发送给数据所有者。"
        },
        {
            p:"2、模型在客户端数据上运行，仅通过神经网络向前馈入，并将预测结果返回给数据所有者 "
        },
        {
            p:"现在，让我们深入了解使用Federated Learning构建示例应用程序的基本步骤。  "
        },
        {
            p:"为了初始化PySyft并确保所有深度学习操作都是安全的，PySyft与PyTorch库“挂钩”。"
        },
        {
            p:"在数据所有者一端，现在需要通过WebsocketServerWorker部署数据，这使联邦学习成为可能。 不同的参数被指定，比如主机IP, PySyft钩子，以及Finastra的PySyft客户端将要连接到的特定端口。 "
        },
        {
            p:"现在数据所有者部署了一个数据集，我们这些数据科学家可以通过PySyft库中定义的WebsocketClientWorker进行连接。"
        },
        {
            p:"接下来，我们可以指定模型及其培训配置。 这些将被发送到每个WebsocketServerWorker(在本例中只有一个)。 由于PySyft位于PyTorch之上，这些都是通过Torch语法定义的。  "
        },
        {
            p:" 现在，函数fit_model_on_worker处理几个步骤。 通过Syft对模型和训练配置进行加密，在数据所有者上对模型进行安全训练，最后检索更新后的模型及其训练损失。 现在需要做的就是调用每个数据所有者的函数。 虽然计算是在数据所有者一方进行的，但所有的训练都是由数据科学家发起的! "
        },
        {
            p:"现在，我们可能已经从每个远程工作者那里获得了几个模型。 剩下的就是通过将所有的权重和参数平均起来，将所有的模型合并成最终的模型。 当然，这也是由PySyft处理的。 "
        },
        {
            p:"在运行所需迭代次数的训练和平均循环后，训练就完成了。 然后，最终的模型可以发送给银行，以预测新客户的贷款风险。 在这个场景中，因为只有一个数据所有者，所以模型性能将与在典型ML管道中训练的模型相同。 但是，当一个模型针对多个数据所有者进行训练时，性能会发生什么变化? "
        },
        {
            p:"这些代码片段基于来自OpenMined github仓库的异步联邦学习教程，该仓库训练MNIST手写数字识别数据的模型。 在本例中，数据按数字分割。 在数据的子集上训练多个模型，然后进行组合。 让我们将联邦学习的性能与研究中的最佳性能进行比较。"
        },
        {
            imgUrl:"@/assets/zhImage/banner1-zh.png"
        },
        {
            p:"由于保证了100%的隐私，联邦学习实现了与传统深度学习技术非常相似的性能。  "
        },
        {
            p:"通过这个过程，我们看到了两个主要的好处。 第一个是联邦学习的主要目标:隐私。 没有银行能够理解模型架构是什么，我们也无法访问任何数据。 第二个好处是提高智能化。 现在，银行能够使用经过大量数据源训练的更健壮的模型，因为该模型是来自其他几家金融机构的信息的顶点。 私人人工智能和联邦学习的应用是巨大的——任何涉及从贷款到信用风险等个人数据的用例，都可以从这些新方法中获益。"
        },

    ]
}